import * as Tooltip from '@radix-ui/react-tooltip';
import { PropsWithChildren, ReactNode, useState } from 'react';
import { Text } from '@pairy/pds-react/src/components/Text';

import * as Styled from './index.styles';

interface ComponentToolTipProps {
  description: ReactNode;
}
const ComponentToolTip = ({
  children,
  description,
}: PropsWithChildren<ComponentToolTipProps>) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Tooltip.Provider>
      <Tooltip.Root delayDuration={0} open={isOpen}>
        <Tooltip.Trigger asChild onClick={(e) => e.preventDefault()}>
          <div
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
          >
            {children}
          </div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.TooltipContent sideOffset={10}>
            <Styled.ContentWrapper>
              <Text variant="sm-medium" color="white" textAlign="center">
                {description}
              </Text>
            </Styled.ContentWrapper>
          </Tooltip.TooltipContent>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default ComponentToolTip;
